import linkedinIcon from "./assets/social/linkedin.png";
import instagramIcon from "./assets/social/instagram.png";
import spotifyIcon from "./assets/social/spotify.png";
import githubIcon from "./assets/social/github.png";

import holo3d from "./assets/holo3d.jpg";

import tunnelapp from "./assets/tunnelapp.jpg";
import tunnelappvideo from "./assets/tunnelappvideo.mp4";

import chatbot from "./assets/chatbot.jpg";
import chatbotVideo from "./assets/chatbot.mp4";

import weightapp from "./assets/weightapp.png";
import weightappvideo from "./assets/weightappvideo.mp4";

import rocketvr from "./assets/rocketvr.png";
import rocketvrvideo from "./assets/rocketvrvideo.mp4";

import vastview from "./assets/vastview.png";
import vastviewvideo from "./assets/vastviewvideo.mp4";

import skeleton from "./assets/skeleton.png"
import skeletonvideo from "./assets/skeletonvideo.mp4"

import cigarattesapp from "./assets/cigarattesapp.png"
import cigarattesappvideo from "./assets/cigarattesappvideo.mp4"

import colabubbles from "./assets/colabubbles.png"
import colabubblesvideo from "./assets/colabubblesvideo.mp4"

import chickensaber from "./assets/chickensaber.png"
import chickensabervideo from "./assets/chickensabervideo.mp4"

import iqoscanon from "./assets/iqoscanon.png"
import iqoscanonvideo from "./assets/iqoscanonvideo.mp4"

import colabackgroundprint from "./assets/colabackgroundprint.jpg";

import iqoscancer from "./assets/iqoscancer.jpeg"
import iqoscancervideo from "./assets/iqoscancervideo.mp4"

import beerpong from "./assets/beerpong.jpeg"
import beerpongvideo from "./assets/beerpongvideo.mp4"

import bodyhit from "./assets/bodyhit.png"
import bodyhitvideo from "./assets/bodyhitvideo.mp4"

import tilt from "./assets/tilt.png"
import tiltvideo from "./assets/tiltvideo.mp4"

import barbiewindows from "./assets/barbiewindows.png"
import barbiewindowsvideo from "./assets/barbiewindowsvideo.mp4"

import boxing from "./assets/boxing.jpg"

import smartpot from "./assets/smartpot.png"

import cancernotetaking from "./assets/cancernotetaking.png"

import octo from "./assets/octo.png"

// Featured project visuals, taken from each project's own repository / preprint:
// Elsewhere: docs/screenshots/generated-site.png (resized)
// Neural MIRA: docs/header.png (resized)
// PeasyFiles: PeasyFilesChromeExtension/icons/ui-preview-640-400.png, upload-file.gif (converted to mp4)
// Quantum-native LMs: title page of arXiv:2610.12806
import elsewhere from "./assets/elsewhere.jpg"
import neuralmira from "./assets/neuralmira.jpg"
import quantumpaper from "./assets/quantumpaper.jpg"
import peasyfiles from "./assets/peasyfiles.png"
import peasyfilesvideo from "./assets/peasyfilesvideo.mp4"

export const paperUrl = "https://arxiv.org/abs/2610.12806";

export const skillGroups = [
  {
    name: "AI & Research",
    skills: ["Python", "Machine Learning", "Deep Learning", "Computer Vision", "Generative Models", "LLM Applications", "AI Agents", "Information Retrieval", "Quantum Machine Learning"],
  },
  {
    name: "Software Engineering",
    skills: ["C#", ".NET", "TypeScript", "JavaScript", "React", "React Native", "Next.js", "Node.js", "Backend Architecture", "API Development"],
  },
  {
    name: "Systems & Interactive Technology",
    skills: ["Rust", "Unity", "XR / VR (Meta Quest)", "Real-time Applications", "Motion Tracking (Kinect, Camera)", "Hardware Integration", "Embedded (Arduino, ESP32, Raspberry Pi)", "WebRTC"],
  },
  {
    name: "Tools & Platforms",
    skills: ["Git & GitHub", "PyTorch", "scikit-learn", "Qiskit & IBM Quantum", "SQLite", "PostgreSQL", "MongoDB", "MySQL", "Firebase", "AWS", "Azure", "Netlify"],
  },
]


export const contactLinks = [
  // { name: 'Stack Overflow', url: 'https://img.icons8.com/external-tal-revivo-color-tal-revivo/40/000000/external-stack-overflow-is-a-question-and-answer-site-for-professional-logo-color-tal-revivo.png', link: 'https://stackoverflow.com/users/11788531/aakash-sharma' },
  // { name: 'Github', url: 'https://img.icons8.com/doodle/40/000000/github--v1.png', link: 'https://github.com/DenizYunus' },
  // { name: 'LinkedIn', url: 'https://img.icons8.com/doodle/40/000000/linkedin--v2.png', link: 'https://www.linkedin.com/in/deniz-yunus-gogus/' },
  // { name: 'Instagram', url: 'https://img.icons8.com/doodle/40/000000/instagram-new--v2.png', link: 'https://www.instagram.com/deniz_yunus.gogus' },
  // { name: 'Spotify', url: 'https://img.icons8.com/doodle/40/000000/spotify--v1.png', link: "https://open.spotify.com/track/55phMMJiqMhc3IRlJvERPD?si=06b0919c5f134bd2" }
  { name: 'Github', url: githubIcon, link: 'https://github.com/DenizYunus' },
  { name: 'LinkedIn', url: linkedinIcon, link: 'https://www.linkedin.com/in/deniz-yunus-gogus/' },
  { name: 'Instagram', url: instagramIcon, link: 'https://www.instagram.com/deniz_yunus.gogus' },
  { name: 'Spotify', url: spotifyIcon, link: "https://open.spotify.com/track/55phMMJiqMhc3IRlJvERPD?si=06b0919c5f134bd2" }
]



export const serviceData = [
  {
    name: 'Software & Product Engineering',
    desc: "Desktop, web and backend software that is built to ship, not just to demo. I work across C# and .NET, Python, TypeScript and React, and Rust, from architecture and APIs down to the installer. Client projects run through Zephio, the company I co-founded.",
    img: "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/64/000000/external-web-development-coding-kiranshastry-lineal-color-kiranshastry.png"
  },
  {
    name: 'AI & Computer Vision Systems',
    desc: "Applied AI that has to work on real data: computer vision on continuous camera feeds, retrieval and ranking systems, and LLM-based tools and agent workflows. I build the pipeline and the integrations around it, plus the evaluation that shows whether it actually works.",
    img: "https://img.icons8.com/external-justicon-lineal-color-justicon/64/000000/external-app-development-responsive-web-design-justicon-lineal-color-justicon.png"
  },

  {
    name: 'XR, Interactive & Hardware',
    desc: "Unity and XR applications for Meta Quest, camera- and Kinect-driven installations for expos and brand activations, and custom hardware on ESP32, Arduino and Raspberry Pi that integrates with the software around it. (Note: I focus on design and development, not physical carpentry :))",
    img: "https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-backend-no-code-flaticons-flat-flat-icons.png"
  },
]



export const projectsData = [
  {
    name: "Elsewhere",
    description: "A native desktop browser for an internet that doesn't exist. Type any address and a language model writes the whole website, HTML, CSS and JavaScript included. From then on it is a permanent part of that world: the same page on every visit, links that lead to newly generated sites, a knowledge graph that keeps people and facts consistent across sites, and edits saved as versions.",
    imgUrl: elsewhere,
    imgAlt: "A generated video-platform website rendered inside Elsewhere",
    link: "https://github.com/DenizYunus/Elsewhere",
    stack: ["Rust", "egui", "WebKit (wry)", "SQLite", "Tantivy", "Axum"],
    tags: ["AI", "Rust", "Desktop", "Open Source"],
    featured: true
  },
  {
    name: "Quantum-Native Language Models",
    description: "Language models whose memory lives inside a small quantum register, trained as learned dissipative quantum channels and run end to end on IBM Heron hardware. An honest study of what works and where the capacity limits are, not a claim of quantum advantage. More in the Research section.",
    imgUrl: quantumpaper,
    imgAlt: "Title page of the preprint Trainable Quantum-Native Language Models",
    links: [{ label: "Read Paper", url: paperUrl }],
    stack: ["Python", "NumPy", "Qiskit", "IBM Quantum"],
    tags: ["Research", "Quantum", "Machine Learning"],
    featured: true
  },
  {
    name: "Neural MIRA",
    description: "Relevance ranking for autobiographical memory. A small neural attention head ranks diary-style memories by fusing semantic similarity with temporal, emotional, people and source-reliability signals, on top of an interpretable BM25 and embedding feature pipeline, so every result shows why it surfaced. Evaluated on held-out time and writing-style splits.",
    imgUrl: neuralmira,
    imgAlt: "Neural MIRA: attention for personal recall",
    link: "https://github.com/DenizYunus/neural-mira",
    stack: ["Python", "PyTorch", "Sentence Transformers", "BM25", "scikit-learn"],
    tags: ["AI", "Information Retrieval", "Open Source"],
    featured: true
  },
  {
    name: "VastView",
    description: "An immersive VR web browser for Meta Quest. A huge browser window sits in front of you: grab it and climb with a rock gesture, click by pointing, and type on a persistent virtual keyboard. Works with hand tracking, controllers or both, with passthrough and gravity or fly movement modes.",
    imgUrl: vastview,
    videoUrl: vastviewvideo,
    link: "https://github.com/DenizYunus/VastView",
    stack: ["Unity", "C#", "Meta Quest", "Hand Tracking"],
    tags: ["XR", "Quest", "Open Source"],
    featured: true
  },
  {
    name: "PeasyFiles",
    description: "PeasyFiles makes browser file uploads easier by bringing your clipboard and recent downloads directly into file selection. A Chrome extension works with a Windows desktop companion, so you can preview and upload files without navigating through folders. It respects each site's upload restrictions and keeps files local. The extension needs the Windows companion app to work.",
    imgUrl: peasyfiles,
    imgAlt: "PeasyFiles upload popup showing clipboard content and recent downloads",
    videoUrl: peasyfilesvideo,
    links: [
      { label: "GitHub", url: "https://github.com/DenizYunus/PeasyFiles" },
      { label: "Chrome Web Store", url: "https://chromewebstore.google.com/detail/peasyfiles/edlblepjgkmphmbhknndfmdnillichef" },
      { label: "Download for Windows", url: "https://github.com/DenizYunus/PeasyFiles/releases/download/Release/PeasyFilesInstaller.exe" },
    ],
    stack: ["JavaScript (Chrome Extension, MV3)", "C# / .NET 8 (WinForms)", "EmbedIO", "Inno Setup"],
    tags: ["Productivity", "Browser Extension", "Windows", "Open Source"],
    featured: true
  },
  {
    name: "AI Character Chatbot",
    description: "OpenAI GPT powered, lipsync supported, custom character, with conversational abilities. Desktop, Mobile, WebGL supported.",
    imgUrl: chatbot,
    videoUrl: chatbotVideo,
    link: "https://github.com/DenizYunus/Freelance_GPTAssistedLipSyncedChatbot",
    tags: ["Desktop", "Mobile", "WebGL", "AI", "Expo"]
  },
  {
    name: "Beer Pong",
    description: "Two monitor, two players, beer pong game, with a scoring system and a winner loser gifting.",
    imgUrl: beerpong,
    videoUrl: beerpongvideo,
    tags: ["Desktop", "Hardware", "Expo"],
    company: "Heineken"
  },
  {
    name: "Body Football",
    description: "Get in front of the camera, and hit the balls with your body, hit as many as you can!",
    imgUrl: bodyhit,
    videoUrl: bodyhitvideo,
    tags: ["Desktop", "AI", "Expo"],
    company: "BitGet"
  },
  {
    name: "Hologram Streaming App",
    description: "WebRTC supported video communication application, shown in a triangular pyramid holographic device.",
    imgUrl: holo3d,
    link: "https://github.com/DenizYunus/StreamingAppWebRTC",
    tags: ["Desktop", "WebRTC", "Expo"]
  },
  {
    name: "VR Rocket Travel",
    description: "Meta Quest application, allows you to fly with jetpacks.",
    imgUrl: rocketvr,
    videoUrl: rocketvrvideo,
    link: "https://github.com/DenizYunus/JetFlyQuests-Quest",
    tags: ["XR", "Quest"]
  },
  {
    name: "Weight/Health App",
    description: "Kinect controlled, health informative application, showing the relation between weight and diseases.",
    imgUrl: weightapp,
    videoUrl: weightappvideo,
    link: "",
    tags: ["Mobile", "Health", "Motion Capture", "Kinect", "Expo"],
    company: "Lilly a Medicine Company"
  },
  {
    name: "Tunnel App",
    description: "Arduino PIR sensors activated video tunnel application showing external loaded videos on 2 different monitors.",
    imgUrl: tunnelapp,
    videoUrl: tunnelappvideo,
    link: "",
    tags: ["Desktop", "Hardware", "Expo"],
    company: "Kaufland"
  },
  {
    name: "Kinect Skeleton App",
    description: "Kinect Controlled, Skeleton Shaped Motion Tracking Application.",
    imgUrl: skeleton,
    videoUrl: skeletonvideo,
    link: "",
    tags: ["Desktop", "Kinect", "Motion Capture", "Expo"]
  },
  {
    name: "Scan&Gift App",
    description: "Bentley Tobacco app for scanning cigarattes and giving gift packets according to remaining stocks.",
    imgUrl: cigarattesapp,
    videoUrl: cigarattesappvideo,
    link: "",
    tags: ["Mobile", "AI", "Hostess", "Expo"],
    company: "Bentley Tobacco"
  },
  {
    name: "VR Chicken Saber",
    description: "A VR app inspired by Beat Saber and Fruit Ninja, fusioned and Chicken Saber is created, SLICE THE CHICKENS!",
    imgUrl: chickensaber,
    videoUrl: chickensabervideo,
    link: "",
    tags: ["XR", "Quest"]
  },
  {
    name: "Coke Bubbles Speech App",
    description: "Speech Recognition app where you tell your name, and it gets shaped with bubbles and saved to database using local TTS model.",
    imgUrl: colabubbles,
    videoUrl: colabubblesvideo,
    link: "",
    tags: ["Desktop", "AI", "Speech Recognition", "Expo"],
    company: "Coca Cola"
  },
  {
    name: "VR Tilt (Arm Workout)",
    description: "A VR Cardio App that combines the use of shoulders and arms actively.",
    imgUrl: tilt,
    videoUrl: tiltvideo,
    link: "",
    tags: ["XR", "Quest", "Fitness"]
  },
  {
    name: "Photo Booth, Smile (:",
    description: "A photo booth app using Canon Camera SDK and prints the photo with some edits.",
    imgUrl: iqoscanon,
    videoUrl: iqoscanonvideo,
    link: "",
    tags: ["Desktop", "Canon Camera", "Photo Upload", "Expo"],
    company: "IQOS"
  },
  {
    name: "Cancer Psychology App",
    description: "People score about cancer and its psychologic facts, and these scores combined in a pool and showed in the end with percentages.",
    imgUrl: iqoscancer,
    videoUrl: iqoscancervideo,
    link: "",
    tags: ["Desktop", "Data Analysis", "Health", "Expo"],
    company: "IQOS"
  },
  {
    name: "Smart Flower Pot",
    description: "A flower pot system designed with Arduino, with custom rules for watering and sending notifications, checking temp, moist, light etc. values.",
    imgUrl: smartpot,
    link: "https://github.com/DenizYunus/Smart-Flower-Pot-Controller",
    tags: ["Mobile", "Hardware", "Agriculture"]
  },
  {
    name: "Calendar & Task Planner",
    description: "Google Calendar integrated, task planning app using Unity for a startup. Made with Unity with frameless windows, solely Unity and C# backend.",
    imgUrl: octo,
    link: "https://github.com/DenizYunus/Google-Calendar-Integrated-Desktop-Startup-Project",
    tags: ["Desktop", "Productivity"]
  },
  {
    name: "Windows 95 - Barbie Themed",
    description: "A fun React project with a sample Windows features styled with Barbie theme. Has multi windows support, minimizing and restoring windows, textbox etc.",
    imgUrl: barbiewindows,
    videoUrl: barbiewindowsvideo,
    link: "https://zingy-tanuki-e87ceb.netlify.app/",
    tags: ["Web"]
  },
  {
    name: "Boxing App",
    description: "An Arduino assisted boxing apps where user punches the boxing rack, and gets health suggestions after each punch.",
    imgUrl: boxing,
    link: "",
    tags: ["Desktop", "Hardware", "Fitness", "Expo"]
  },
  {
    name: "Cancer Note Taking App",
    description: "For a health fair, an application shown on a big touch screen letting people share their thoughts about the product with some pre-defined keywords.",
    imgUrl: cancernotetaking,
    link: "",
    tags: ["Desktop", "Health", "Data Analysis", "Expo"],
    company: "AstraZeneca"
    // company: "ÎMPREUNĂ PENTRU VIAȚĂ"
    // company: "Votez Pentru Sanatate"
  },
  {
    name: "Coke Backgroundless Printer",
    description: "An app that removes the background of the photo you took inside the app, and prints it with some additional stickers.",
    imgUrl: colabackgroundprint,
    link: "",
    tags: ["Desktop", "AI", "Printer", "Expo"],
    company: "Coca Cola"
  },
]

export const fullTimeCompanies = [
  {
    name: "UESTCO",
    role: "AI Engineer",
    period: "Jan 2026 – Present · Remote",
    description: "Building practical AI systems for intelligent video monitoring: computer vision and automated analysis of continuous camera feeds. I design scalable AI pipelines and the integrations around them, and explore agent-based architectures for decision support."
  },
  {
    name: "Zephio",
    role: "Co-Founder",
    period: "Active venture",
    description: "Zephio delivers software, digital products and interactive technology for clients, from custom applications to installations for events and exhibitions. I lead technical execution from scoping and architecture through building and delivery, and work on the products and commercial side of the business.",
    link: "https://zephio.tech"
  },
  {
    name: "CoreXas Consulting Group",
    role: "Full Stack Developer",
    period: "2024 – 2025",
    description: "Led development of multiple client projects using .NET, Unity, and web technologies, focusing on innovative applications and enterprise solutions."
  },
  {
    name: "Monster Notebook",
    role: "Desktop Developer",
    period: "2022 – 2024",
    description: "Developed high-performance applications and tools for gaming laptops. Created custom software solutions for hardware optimization and user experience."
  },
  {
    name: "Kuvars Tech",
    role: "Unity XR Developer",
    period: "Oct 2020 – Mar 2022",
    description: "Built XR applications in Unity and C#, bringing new technologies into XR projects and working closely with the game design team to turn their designs into working software."
  }
];

export const education = [
  {
    name: "EIT Digital Master School",
    role: "Double-Degree Master's Programme · In Progress",
    period: "2025 – 2027",
    description: "An international master's programme run across two European universities, covering artificial intelligence and machine learning, data science, deep learning and generative modelling, alongside research and entrepreneurship.",
    details: [
      "University of Turku, Finland: Data Science (exit year, 2026 – 2027, current)",
      "Eötvös Loránd University (ELTE), Budapest, Hungary: Emotion AI (first year, 2025 – 2026)",
    ]
  },
  {
    name: "Istanbul Aydın University",
    role: "BSc, Computer Engineering",
    period: "2019 – 2024",
    description: "President of the university's Research and Development Club, software and electronics lead of the NOVA UAV team, and software lead of the STARSAT model satellite team."
  }
];

export const achievements = [
  {
    name: "EIT Digital Business Challenge",
    role: "Winner",
    period: "2025",
    description: "Won as part of a team; I presented our startup concept."
  },
  {
    name: "REDINEST",
    role: "Best Student Mentor",
    period: "2026"
  }
];